import { render, staticRenderFns } from "./Dialog_GiveTemplateToSemester.vue?vue&type=template&id=e37dda9c&scoped=true&"
import script from "./Dialog_GiveTemplateToSemester.vue?vue&type=script&lang=js&"
export * from "./Dialog_GiveTemplateToSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37dda9c",
  null
  
)

export default component.exports